import EditBrand from './components/EditBrand';
import { bindActionCreators } from 'redux';
import withRouter from 'react-router/withRouter';
import get from 'lodash/get';
import values from 'lodash/values';
import { connect } from 'react-redux';

import {
  loadUsersForAgency,
  loadBrand,
  loadRetailer,
  createBrand,
  updateBrand,
  createRetailer,
  updateRetailer
} from '../../shared/redux/entities/actions';

function getAgencyId(state){
  const impersonatedUserId = get(state,['entities','impersonatedUserId']),
    activeUserId = get(state,['entities','activeUserId']);

    if(impersonatedUserId){
      return get(state,['entities','users',impersonatedUserId,'agencyId']);
    } else {
      return get(state,['entities','users',activeUserId,'agencyId']);
    }
}

function mapStateToProps(state,props){
  const brandId = props.match.params.brandId,
    agencyId = getAgencyId(state);

  return {
    agencyId:agencyId,
    brandId:brandId,
    isCreate:brandId === 'new',
    name:get(state,['entities','companies',brandId,'name']),
    contactUserId:get(state,['entities','companies',brandId,'contactUserId']),
    users:values(get(state,['entities','users'],{})).filter((u) => u.agencyId === agencyId),
    primaryColor:get(state,['entities','companies',brandId,'primaryColor']),
    logoURL:get(state,['entities','companies',brandId,'logoURL']),
    logoId:get(state,['entities','companies',brandId,'logoId']),
    logoFileName:get(state,['entities','companies',brandId,'logoFileName'])
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    loadBrand,
    loadUsersForAgency,
    loadRetailer,
    updateBrand,
    createBrand,
    updateRetailer,
    createRetailer
  },dispatch)
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(EditBrand));



// WEBPACK FOOTER //
// ./src/routes/EditBrand/index.js